<template>
  <div class="control-group"
      :class="{
        'invalid': input_invalids && input_invalids[input_name],
        'disabled': input_disabled
      }">
      <ul class="control radio-group" :class="{'required': input_required}">
          <li v-for="(option, index) in options" :key="'i_r_' + index">
            <input
              :id="input_id + index"
              type="radio"
              :value="option"
              v-model="model_value"
              :disabled="input_disabled"
              @change="onChangeValue"
            >
            <label :for="input_id + index">
              {{ tag_text ? Language.say(`${tag_text}${index}`) : index }}
            </label>
          </li>
      </ul>
      <p class="error" v-if="input_invalids && input_invalids[input_name]">
        {{ Language.say(error_text) }}
      </p>
  </div>
</template>

<script setup>
  import {defineProps, defineEmits, ref} from 'vue';
  import Language                        from '@/js/Shared/Language/Language';

  const props = defineProps({
    input_id: {
      type: String,
      default: 'radio',
    },
    input_name: {
      type: String,
      required: true,
    },
    input_required: {
      type: Boolean,
      default: false
    },
    input_invalids: {
      type: Object,
      default : () => ({}),
    },
    input_value: {
      type: [String, Number, Boolean],
      default: ''
    },
    input_disabled: {
      type: Boolean,
      default: false,
    },
    tag_text: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      required: true
    },
    label_text: {
      type: String,
      default: ''
    },
    error_text: {
      type: String,
      default: 'global.forms.invalid.input'
    },
  });

  const emit = defineEmits(['change', 'update:input_value']);

  const model_value = ref(props.input_value);

  const onChangeValue = () => {
    emit('change'            , model_value.value);
    emit('update:input_value', model_value.value);
  }
</script>
